import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFetchUserProfile } from 'actions/userProfile';
import { PROFILE_ROUTES } from 'utils/routes';
import PageTitle from 'components/PageTitle';
import Landmark from 'components/Landmark';
import UserSkillsWidget from 'screens/UserSkills';
function StandaloneSkillsProfilePage() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useFetchUserProfile = useFetchUserProfile(),
    userProfile = _useFetchUserProfile.userProfile,
    isUserProfileLoading = _useFetchUserProfile.isLoading;
  var isLoading = isUserProfileLoading || !userProfile;
  if (isLoading) {
    return /*#__PURE__*/React.createElement(Landmark, {
      icon: "spinner"
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageTitle, {
    visuallyHidden: true
  }, t('navbar_my_skills')), /*#__PURE__*/React.createElement(UserSkillsWidget, {
    userAnalysisRoutes: {
      root: PROFILE_ROUTES.skills,
      skill: PROFILE_ROUTES.skillsSkill,
      meeting: PROFILE_ROUTES.skillsMeeting
    }
  }));
}
export default StandaloneSkillsProfilePage;